import EventBus from 'diagram-js/lib/core/EventBus';
import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import { NodeOpenNotes } from "@ispm-client/modules/bpmn-modeler/store/actions";
import { Store } from "@ngrx/store";
import { State } from "@ispm-client/modules/bpmn-modeler/store/state";
import { ModelingUtil } from "@ispm/shared/bpmn-io/modeling-util";
import { EventType } from "@ispm/shared/bpmn-io/bpmn-js";
import {OverlayType} from "@ispm/shared/bpmn-io/overlay-types";

export class NodeOpenNotesButtonOverlayBehavior extends CommandInterceptor {

  private overlayType: string = OverlayType.nodeOpenNotesButtonOverlay;
  private lastNode;

  constructor(protected eventBus: EventBus, private overlays, private store$: Store<State>, private config) {
    super(eventBus);
    const disableNotesPerNode = config && config.behavior && config.behavior.allowNotesPerNode === false;
    if (disableNotesPerNode) {
      return;
    }
    const self = this;
    eventBus.on(EventType.SELECTION_CHANGED, function(e) {
      const selection = e.newSelection;
      if (selection.length === 1) {
        const element = selection[0];
        const overlay = self.getOverlay(element);
        if (element === self.lastNode && overlay && overlay.length > 0) {
          return;
        } else {
          self.removeLastNodeOverlay();
        }
        if (!ModelingUtil.isNode(element)) {
          self.lastNode = null;
          return;
        }
        if (overlay && overlay.length === 0) {
          self.addOverlay(element);
        }
        self.lastNode = element;
      } else {
        self.removeLastNodeOverlay();
      }
    });
  }

  private removeLastNodeOverlay() {
    if (this.lastNode) {
      this.overlays.remove({element: this.lastNode, type: this.overlayType});
      this.lastNode = null;
    }
  }

  private getOverlay(element) {
    return this.overlays.get({element: element, type: this.overlayType});
  }

  private addOverlay(element) {
    let leftVal = -5, topVal = -48;
    this.overlays.add(element.id, this.overlayType, {
      position: {
        top: topVal,
        left: leftVal
      },
      html: `<div class="pathways-context-pad-icon node-notes-button icon__dls-notes"></div>`
    });
    const overlay = this.getOverlay(element);
    let button = overlay[0].htmlContainer;
    button.onclick = () => this.openNotes(element);
    button.title = "Add note";
  }

  private openNotes(element) {
    this.store$.dispatch(new NodeOpenNotes({ node: element }));
  }
}

NodeOpenNotesButtonOverlayBehavior.$inject = ['eventBus', 'overlays', 'store$', 'config'];
